import { cn } from "@babackapp/ui/lib/utils";
import { Column, Container, Img, Row, Link } from "@react-email/components";
import { useEmailThemeRadius } from "../../hooks/use-emails-theme-radius";
import { BannerBlockProps } from "./types";


export function BannerEmailRenderer(props: BannerBlockProps) {
  const imageRadius = useEmailThemeRadius(props.theme, "bannerImage");

  const item = props.block.properties?.items?.[0];

  const itemHref = item?.href;
  const imageUrl = item?.imageId
    ? `https://baback-banner-images.s3.eu-west-3.amazonaws.com/${item.imageId}`
    : (item?.imageUrl ?? "#");

  const width = props.emailBlockWidth;

  // Outlook desktop ignores CSS widths and renders images at their intrinsic
  // size (a 5000px upload blew up the whole email), so the HTML `width`
  // attribute pins it; max-width caps it in clients that ignore the
  // container's max-width.
  const image = (
    <Img
      src={imageUrl}
      alt="Banner"
      width={width}
      style={{
        width: "100%",
        maxWidth: width ? `${width}px` : "100%",
        height: "auto",
      }}
      className={cn(imageRadius, "object-cover block mr-2")}
    />
  );

  return (
    <Container className="w-full">
      <Row>
        <Column>
          {itemHref ? <Link href={itemHref}>{image}</Link> : image}
        </Column>
      </Row>
    </Container>
  );
}
